import type { SupportedLocale } from "@safesphere/contracts";

import { getBundleStorageSnapshot, restoreKnownGoodBundle } from "./database.js";

export const contentAvailabilityStates = [
  "READY",
  "NEVER_DOWNLOADED",
  "UPDATING",
  "STALE_USABLE",
  "UPDATE_FAILED_USING_SAVED",
  "RECOVERY_REQUIRED",
] as const;

export type ContentAvailabilityState = (typeof contentAvailabilityStates)[number];
export const defaultStaleAfterMilliseconds = 30 * 24 * 60 * 60 * 1000;

export async function determineContentAvailability(
  locale: SupportedLocale,
  now = Date.now(),
  staleAfterMilliseconds = defaultStaleAfterMilliseconds,
): Promise<ContentAvailabilityState> {
  const snapshot = await getBundleStorageSnapshot(locale);

  if (snapshot.activeBundle !== undefined) {
    const publishedAt = Date.parse(snapshot.activeBundle.bundle.body.publishedAt);
    return now - publishedAt > staleAfterMilliseconds ? "STALE_USABLE" : "READY";
  }

  if (snapshot.activePointerExists) {
    const recovered = await restoreKnownGoodBundle(locale);
    return recovered === undefined ? "RECOVERY_REQUIRED" : "UPDATE_FAILED_USING_SAVED";
  }

  return "NEVER_DOWNLOADED";
}
